import { QueryClient } from '@tanstack/react-query'

// Единый экземпляр: его делят QueryProvider (рендер), роутер-контекст (гейты
// beforeLoad читают кэш без хуков) и 401-хендлер bootstrap'а.
// refetchOnWindowFocus включён: реалтайма у бэка нет, календарь освежается
// при возврате во вкладку (см. docs/stack/api.md).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: { retry: 0 },
  },
})
